import { LoadingFile } from '@components/SiteUserUpload/Components/Steps/components/LoadingFile';
import { FC } from 'react';

type FileUploadInProgressViewProps = {
  file: File | null | undefined;
};

export const FileUploadInProgressView: FC<FileUploadInProgressViewProps> = ({
  file,
}) => {
  return (
    <LoadingFile
      text={file?.name}
      currentSubStep={1}
      subTitle={
        'File upload can take some time. Do not close this modal, otherwise upload\n will be interrupted and provided data will be discarded'
      }
    />
  );
};

type FileUploadErrorViewProps = {
  handleTryAgain: () => void;
};

export const FileUploadErrorView: FC<FileUploadErrorViewProps> = ({
  handleTryAgain,
}) => {
  return (
    <LoadingFile
      text={'Upload Failed'}
      currentSubStep={1}
      subTitle={
        'File upload failed. Please try again. If the issue persists,\ncontact support for assistance.'
      }
      spinnerType={'Semicircle'}
      tryAgainFunc={handleTryAgain}
      tryAgainButton
      semicircleColor='text-vermilion'
    />
  );
};
